var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01 align center"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.338 0.833055C12.9707 0.502491 12.4941 0.31958 12 0.31958C11.5059 0.31958 11.0293 0.502491 10.662 0.833055L0 10.4291V20.8291C0 21.6778 0.337142 22.4917 0.937258 23.0918C1.53737 23.6919 2.35131 24.0291 3.2 24.0291H20.8C21.6487 24.0291 22.4626 23.6919 23.0627 23.0918C23.6629 22.4917 24 21.6778 24 20.8291V10.4291L13.338 0.833055ZM15 22.0261H9V17.0001C9 16.2044 9.31607 15.4413 9.87868 14.8787C10.4413 14.3161 11.2044 14.0001 12 14.0001C12.7956 14.0001 13.5587 14.3161 14.1213 14.8787C14.6839 15.4413 15 16.2044 15 17.0001V22.0261ZM22 20.8261C22 21.1443 21.8736 21.4495 21.6485 21.6746C21.4235 21.8996 21.1183 22.0261 20.8 22.0261H17V17.0001C17 15.674 16.4732 14.4022 15.5355 13.4645C14.5979 12.5268 13.3261 12.0001 12 12.0001C10.6739 12.0001 9.40215 12.5268 8.46447 13.4645C7.52678 14.4022 7 15.674 7 17.0001V22.0261H3.2C2.88174 22.0261 2.57652 21.8996 2.35147 21.6746C2.12643 21.4495 2 21.1443 2 20.8261V11.3191L12 2.31906L22 11.3191V20.8261Z",
    fill: "#ADB5BD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.91fadb1eda3cb95162acb954fef9062e.svg";
export { ForwardRef as ReactComponent };